module.exports = __webpack_public_path__ + "static/media/BoxPlotMCQ3_5.2fa8e0cd.svg";